import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Category } from 'src/app/entities/category';

@Component({
  selector: 'app-menu-nested-item',
  templateUrl: './menu-nested-item.component.html',
  styleUrls: ['./menu-nested-item.component.scss']
})
export class MenuNestedItemComponent implements OnInit {

  @Input() items: Category[];
  @ViewChild('childMenu', { static: true }) public childMenu;

  constructor(public router: Router) {
  }

  ngOnInit() {
  }

}
